import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const PHARMA_ENROLL = defineAction(
  'PHARMA_ENROLL',
  ['CHANGE_STEP', 'UPDATE_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_PHARMA_ENROLL_FORM = defineAction(
  'SUBMIT_PHARMA_ENROLL_FORM',
  httpActions,
);
